import "./App.css";
import React, { useEffect } from 'react';
import OneSignal from 'react-onesignal';
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./components/Home";
import Locations from "./components/Locations";
import Laundry from "./components/Laundry";
import Application from './components/Application'
import Festive from "./components/Festive";
import Jetwash from "./components/Jetwash";
import MobileApp from "./components/MobileApp"
import StoreDetails from "./components/StoreDetails";

function App() {
 
  useEffect(() => {
    OneSignal.init({
      appId: "90e896c0-ceb5-4e1b-8b77-a1b9a5b27958"
    });
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/locations" element={<Locations />} />
          <Route path="/laundry" element={<Laundry />} />
          <Route path="/apply" element={<Application />} />
          {/* <Route path="/festive" element={<Festive />} /> */}
          <Route path="/jetwash" element={<Jetwash/>}/>
          <Route path="/app" element={<MobileApp/>}/>
          {/* <Route path="/store/:id" element={<StoreDetails />} /> */}
          <Route path="/:name" element={<StoreDetails />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
